<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        class="mt-5"
        height="auto"
        @submit="updateShowLoyalty({type: 'rc_app_visible_loyalty_program'})"
    >
        <h4 class="secondary--text" v-text="translations.info[lang]"></h4>
        <v-radio-group class="mt-3 pt-0" hide-details v-model="showLoyalty">
            <v-radio color="secondary" value="true">
                <template v-slot:label>
                    <h4
                        class="subtitle-2 secondary--text"
                        v-text="translations.yes[lang]"
                        
                    ></h4>
                </template>
            </v-radio>
            <v-radio color="secondary" value="false">
                <template v-slot:label >
                    <h4
                        class="subtitle-2 secondary--text"
                        v-text="translations.no[lang]"
                         
                    ></h4>
                </template>
            </v-radio>
        </v-radio-group>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/showLoyalty";
import { mapState,mapGetters, mapMutations, mapActions } from "vuex";
export default {
    name: "ShowLoyalty",

    mixins: [translations],
    data (){
        return {
        }
    },
   
    computed: {
        lang() {
            return this.$route.params.lang;
        },

        showLoyalty: {
            get(){
                 return this.$store.state.loyaltyPanel.businessProfile.showLoyalty;
            },
            set(val){
                this.setShowLoyalty(val);
            }
        }
        
    },
    methods:{
        ...mapMutations("loyaltyPanel/businessProfile", ["setShowLoyalty"]),
        ...mapActions("loyaltyPanel/businessProfile", [
            "updateShowLoyalty"
        ]),
    }
    
};
</script>
